import {PermissionsModel} from '../../../../../common/entity/permissions.model';
import {SummaryModel} from '../../../../../common/entity/summary.model';
import {LovValueSummary} from '../../../../../common/lov/lov-value/api/model/lovValueSummary.model';

export class FormDefinitionFieldSummaryModel implements SummaryModel {
    id: number;
    name: string;
    label: string;
    shortLabel: string;
    permissions: PermissionsModel;
    context: LovValueSummary;
    type: LovValueSummary;
    subType: LovValueSummary
    active: boolean;
    computed: boolean;
    popupContent: string;
    accountId: number;
    labelId: number;

    isImage(): boolean {
        return this.type?.value === FormDefinitionFieldType.FORM_DEFINITION_FIELD_TYPE_PICTURE
            || this.type?.value === FormDefinitionFieldType.FORM_DEFINITION_FIELD_TYPE_PICTURE
            || this.type?.value === FormDefinitionFieldType.FORM_DEFINITION_FIELD_TYPE_DRAWABLE_IMAGE
            || this.type?.value === FormDefinitionFieldType.FORM_DEFINITION_FIELD_TYPE_DRAWABLE_IMAGE_V2
            || this.subType?.value === FormDefinitionFieldSubType.FORM_DEFINITION_FIELD_SUBTYPE_IMAGE;
    }
}

export const FORM_CONTEXT_LOV_LIST = 'FORM_CONTEXT';

export enum FormDefinitionFieldType {
    FORM_DEFINITION_FIELD_TYPE_NEGATIVE_POSITIVE = 'FORM_DEFINITION_FIELD_TYPE_NEGATIVE_POSITIVE',
    FORM_DEFINITION_FIELD_TYPE_YES_NO = 'FORM_DEFINITION_FIELD_TYPE_YES_NO',
    FORM_DEFINITION_FIELD_TYPE_CHOICE = 'FORM_DEFINITION_FIELD_TYPE_CHOICE',
    FORM_DEFINITION_FIELD_TYPE_NUMERIC = 'FORM_DEFINITION_FIELD_TYPE_NUMERIC',
    FORM_DEFINITION_FIELD_TYPE_TEXT = 'FORM_DEFINITION_FIELD_TYPE_TEXT',
    FORM_DEFINITION_FIELD_TYPE_PICTURE = 'FORM_DEFINITION_FIELD_TYPE_PICTURE',
    FORM_DEFINITION_FIELD_TYPE_RICH_TEXT = 'FORM_DEFINITION_FIELD_TYPE_RICH_TEXT',
    FORM_DEFINITION_FIELD_TYPE_JSON = 'FORM_DEFINITION_FIELD_TYPE_JSON',
    FORM_DEFINITION_FIELD_TYPE_EMBEDDED_FILE = 'FORM_DEFINITION_FIELD_TYPE_EMBEDDED_FILE',
    FORM_DEFINITION_FIELD_TYPE_DRAWABLE_IMAGE = 'FORM_DEFINITION_FIELD_TYPE_DRAWABLE_IMAGE',
    FORM_DEFINITION_FIELD_TYPE_DRAWABLE_IMAGE_V2 = 'FORM_DEFINITION_FIELD_TYPE_DRAWABLE_IMAGE_V2',
    FORM_DEFINITION_FIELD_TYPE_DOCUMENT = 'FORM_DEFINITION_FIELD_TYPE_DOCUMENT',
    FORM_DEFINITION_FIELD_TYPE_VIDEO_ANALYSIS = 'FORM_DEFINITION_FIELD_TYPE_VIDEO_ANALYSIS'
}

export enum FormDefinitionFieldSubType {
    FORM_DEFINITION_FIELD_SUBTYPE_LONGTEXT = 'FORM_DEFINITION_FIELD_SUBTYPE_LONGTEXT',
    FORM_DEFINITION_FIELD_SUBTYPE_SELECT_MANY = 'FORM_DEFINITION_FIELD_SUBTYPE_SELECT_MANY',
    FORM_DEFINITION_FIELD_SUBTYPE_IMAGE = 'FORM_DEFINITION_FIELD_SUBTYPE_IMAGE',
    FORM_DEFINITION_FIELD_SUBTYPE_PDF = 'FORM_DEFINITION_FIELD_SUBTYPE_PDF',
    FORM_DEFINITION_FIELD_SUBTYPE_EMBEDDED_FILE = 'FORM_DEFINITION_FIELD_SUBTYPE_EMBEDDED_FILE'
}
